/**
 * The microphone chosen in the desktop app's Settings (Voice → Input), so
 * dictation in the app uses the same mic as Quick Ask and meeting notes.
 *
 * Device ids are scoped per origin in Chromium, so the shell's Settings
 * window and this page see different ids for the same mic: match by label.
 * A mic picked in the composer's own input menu still wins (it is stored by
 * useVoiceDictation and checked first).
 */
import { getDesktopBridge } from './bridge'

let preferredLabel: string | null = null
let unsubscribe: (() => void) | null = null

/** Follow the shell's voice settings (idempotent). */
export function startPreferredMicSync(): void {
    const bridge = getDesktopBridge()
    if (!bridge || unsubscribe) return
    bridge.settings.get().then((s) => { preferredLabel = s?.voice?.inputDeviceLabel ?? null }).catch(() => {})
    unsubscribe = bridge.settings.onChange((s) => { preferredLabel = s?.voice?.inputDeviceLabel ?? null })
}

/** The `audioinput` device id matching the desktop preference, if any. */
export function desktopPreferredInput(inputs: Pick<MediaDeviceInfo, 'deviceId' | 'label'>[]): string | null {
    if (!preferredLabel) return null
    const want = preferredLabel.trim().toLowerCase()
    const hit = inputs.find((d) => d.label && d.label.trim().toLowerCase() === want)
    return hit?.deviceId ?? null
}

/** Test hook. */
export function setPreferredMicLabelForTest(label: string | null): void {
    preferredLabel = label
}
